import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { MapResponse } from '../helper/helper-api';

export const getMedia = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get('/api/media', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const uploadMedia = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/media', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const removeMedia = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .delete(`api/media/${params.id}`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getMediaById = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`api/media/${params.id}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const updateMediaById = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`api/media/${params.id}`, {mediaCategoryId: params.mediaCategoryId, fileName: params.fileName})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getCategoriesMedia = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get('api/media/categories', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const setCopyMediaToProject = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`api/media/${params.mediaId}/copied-to-projects`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const checkCopyMedia = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(`api/media/${params.mediaId}/copied-to-projects/${params.projectId}`, params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const getProjectList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get('/api/projects/select-list', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

export const checkCopyMediaByRegion = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .put(`/api/media/${params.mediaId}/copied-to-projects/bulk-check`, {projectIds: params.projectIds})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/MediaLibrary/api.js